import { render, staticRenderFns } from "./layout-picker.vue?vue&type=template&id=61ea954e&"
import script from "./layout-picker.vue?vue&type=script&lang=js&"
export * from "./layout-picker.vue?vue&type=script&lang=js&"
import style0 from "./layout-picker.vue?vue&type=style&index=0&id=61ea954e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports